const loadingScreen = document.getElementById("app-loading");
const skipBootScreen = /^#\/(?:login|mobile\/login|agreement)(?:[/?]|$)/.test(window.location.hash);
const setProgress = skipBootScreen ? () => {} : window.__setBootProgress || (() => {});
const minimumBootDuration = skipBootScreen
  ? 0
  : Number(import.meta.env.VITE_BOOT_MIN_DURATION || 3000);

if (skipBootScreen) {
  clearInterval(window.__bootPulse);
  loadingScreen?.remove();
}

async function bootstrap() {
  try {
    setProgress(22, "正在加载应用模块…");
    const [{ createApp, nextTick }, { createPinia }, { default: App }, { default: router }] =
      await Promise.all([
        import("vue"),
        import("pinia"),
        import("./App.vue"),
        import("./router"),
        import("./styles/main.scss"),
      ]);

    setProgress(68, "正在初始化页面…");
    const app = createApp(App);
    const pinia = createPinia();
    app.use(pinia);
    const [
      { setUnauthorizedHandler },
      { useAuthStore },
      { isMobileBrowser },
      { setSessionRevokedHandler },
    ] = await Promise.all([
      import("./services/http"),
      import("./features/auth/stores/auth"),
      import("./utils/device"),
      import("./features/auth/services/presenceSseService"),
    ]);
    const returnToLogin = () => {
      useAuthStore(pinia).markGuest();
      const current = router.currentRoute.value;
      if (current.meta.public) return;
      router.replace({
        name: isMobileBrowser() ? "mobile-login" : "login",
        query: { redirect: current.fullPath },
      });
    };
    setUnauthorizedHandler((error) => {
      if (String(error.config?.url || "").includes("/api/auth/me")) return;
      returnToLogin();
    });
    setSessionRevokedHandler(returnToLogin);
    app.use(router);

    await router.isReady();
    setProgress(86, "正在加载首页…");
    app.mount("#app");
    await nextTick();

    setProgress(94, "即将进入大厅…");
    const elapsed = performance.now() - (window.__bootStartedAt || performance.now());
    const remaining = Math.max(0, minimumBootDuration - elapsed);
    if (remaining) await new Promise((resolve) => window.setTimeout(resolve, remaining));

    setProgress(100, "加载完成");
    clearInterval(window.__bootPulse);
    requestAnimationFrame(() => {
      loadingScreen?.classList.add("is-complete");
      window.setTimeout(() => loadingScreen?.remove(), 480);
    });
  } catch (error) {
    clearInterval(window.__bootPulse);
    loadingScreen?.classList.add("is-error");
    setProgress(100, "加载失败，请按 Ctrl + F5 重试");
    console.error("Application bootstrap failed:", error);
  }
}

bootstrap();
